import { Container, Image } from 'gf-ui';
import React from 'react';

const Home = () => {  
  return <Container className='p-0 bg-white rounded overflow-hidden text-center'> 
    <Image src={`${process.env.REACT_APP_BASE_URL_PROD}stsInternet/images/layout/web/logoEnte.jpg`} className="header-logo" />
    <h1 className="text-primary my-4 py-4">PORTALE QUESTIONARI</h1>
  </Container> 
}

export default Home;